import React, { useState, useEffect } from 'react';
import { customerTexts } from '../contexts/LangHO2';

import c01_schneiderImg from '../assets/images/halcyon/customer/c01-schneider.png';
import c02_silverImg from '../assets/images/halcyon/customer/c02-silver.png';
import c03_simonschusterImg from '../assets/images/halcyon/customer/c03-simonschuster.png';
import c04_southernImg from '../assets/images/halcyon/customer/c04-southern.png';
import c05_summitpublicschoolsImg from '../assets/images/halcyon/customer/c05-summitpublicschools.png';
import c06_healthdepartmentImg from '../assets/images/halcyon/customer/c06-healthdepartment.png';
import c07_templehealthImg from '../assets/images/halcyon/customer/c07-templehealth.png';
import c08_tetonImg from '../assets/images/halcyon/customer/c08-teton.png';
import c09_tooelecountImg from '../assets/images/halcyon/customer/c09-tooelecount.png';
import c10_toyotaImg from '../assets/images/halcyon/customer/c10-toyota.png';
import c11_tyroneareaImg from '../assets/images/halcyon/customer/c11-tyronearea.png';
import c12_yutajazzImg from '../assets/images/halcyon/customer/c12-yutajazz.png';
import c13_urbanImg from '../assets/images/halcyon/customer/c13-urban.png';
import c14_usrenalcareImg from '../assets/images/halcyon/customer/c14-usrenalcare.png';
import c15_varsitybrandsImg from '../assets/images/halcyon/customer/c15-varsitybrands.png';
import c16_ahlstromImg from '../assets/images/halcyon/customer/c16-ahlstrom.png';
import c17_allegroImg from '../assets/images/halcyon/customer/c17-allegro.png';
import c18_austinImg from '../assets/images/halcyon/customer/c18-austin.png';
import c19_bluelinxImg from '../assets/images/halcyon/customer/c19-bluelinx.png';
import c20_cacccargolinxImg from '../assets/images/halcyon/customer/c20-cacccargolinx.png';
import c21_caesarsImg from '../assets/images/halcyon/customer/c21-caesars.png';
import c22_chipotleImg from '../assets/images/halcyon/customer/c22-chipotle.png';
import c23_cinemarkImg from '../assets/images/halcyon/customer/c23-cinemark.png';
import c24_deloitteImg from '../assets/images/halcyon/customer/c24-deloitte.png';
import c25_deltadentalImg from '../assets/images/halcyon/customer/c25-deltadental.png';
import c26_eastmanImg from '../assets/images/halcyon/customer/c26-eastman.png';
import c27_eulessImg from '../assets/images/halcyon/customer/c27-euless.png';
import c28_framinghamImg from '../assets/images/halcyon/customer/c28-framingham.png';
import c29_freshfieldsImg from '../assets/images/halcyon/customer/c29-freshfields.png';
import c30_garlandImg from '../assets/images/halcyon/customer/c30-garland.png';
import c31_graybarImg from '../assets/images/halcyon/customer/c31-graybar.png';
import c32_irprosImg from '../assets/images/halcyon/customer/c32-irpros.png';
import c33_intermountainhealthImg from '../assets/images/halcyon/customer/c33-intermountainhealth.png';
import c34_jmfamilyImg from '../assets/images/halcyon/customer/c34-jmfamily.png';
import c35_jsheldImg from '../assets/images/halcyon/customer/c35-jsheld.png';
import c36_kansasImg from '../assets/images/halcyon/customer/c36-kansas.png';
import c37_mckinneyImg from '../assets/images/halcyon/customer/c37-mckinney.png';
import c38_peerlessImg from '../assets/images/halcyon/customer/c38-peerless.png';
import c39_qdobaImg from '../assets/images/halcyon/customer/c39-qdoba.png';
import c40_rogueImg from '../assets/images/halcyon/customer/c40-rogue.png';

function ProductHOCustomer2({ lang = 'ko', isMobile = false }) {
  const [currentIndex, setCurrentIndex] = useState(12); // 중간 섹션에서 시작
  const [isTransitioning, setIsTransitioning] = useState(true);

  // 12개의 상 정보를 배열로 정리
  const prizes = [
    { key: 'c01_schneider', image: c01_schneiderImg},
    { key: 'c02_silver', image: c02_silverImg},
    { key: 'c03_simonschuster', image: c03_simonschusterImg},
    { key: 'c04_southern', image: c04_southernImg},
    { key: 'c05_summitpublicschools', image: c05_summitpublicschoolsImg},
    { key: 'c06_healthdepartment', image: c06_healthdepartmentImg},
    { key: 'c07_templehealth', image: c07_templehealthImg},
    { key: 'c08_teton', image: c08_tetonImg},
    { key: 'c09_tooelecount', image: c09_tooelecountImg},
    { key: 'c10_toyota', image: c10_toyotaImg},
    { key: 'c11_tyronearea', image: c11_tyroneareaImg},
    { key: 'c12_yutajazz', image: c12_yutajazzImg},
    { key: 'c13_urban', image: c13_urbanImg},
    { key: 'c14_usrenalcare', image: c14_usrenalcareImg},
    { key: 'c15_varsitybrands', image: c15_varsitybrandsImg},
    { key: 'c16_ahlstrom', image: c16_ahlstromImg},
    { key: 'c17_allegro', image: c17_allegroImg},
    { key: 'c18_austin', image: c18_austinImg},
    { key: 'c19_bluelinx', image: c19_bluelinxImg},
    { key: 'c20_cacccargolinx', image: c20_cacccargolinxImg},
    { key: 'c21_caesars', image: c21_caesarsImg},
    { key: 'c22_chipotle', image: c22_chipotleImg},
    { key: 'c23_cinemark', image: c23_cinemarkImg},
    { key: 'c24_deloitte', image: c24_deloitteImg},
    { key: 'c25_deltadental', image: c25_deltadentalImg},
    { key: 'c26_eastman', image: c26_eastmanImg},
    { key: 'c27_euless', image: c27_eulessImg},
    { key: 'c28_framingham', image: c28_framinghamImg},
    { key: 'c29_freshfields', image: c29_freshfieldsImg},
    { key: 'c30_garland', image: c30_garlandImg},
    { key: 'c31_graybar', image: c31_graybarImg},
    { key: 'c32_irpros', image: c32_irprosImg},
    { key: 'c33_intermountainhealth', image: c33_intermountainhealthImg},
    { key: 'c34_jmfamily', image: c34_jmfamilyImg},
    { key: 'c35_jsheld', image: c35_jsheldImg},
    { key: 'c36_kansas', image: c36_kansasImg},
    { key: 'c37_mckinney', image: c37_mckinneyImg},
    { key: 'c38_peerless', image: c38_peerlessImg},
    { key: 'c39_qdoba', image: c39_qdobaImg},
    { key: 'c40_rogue', image: c40_rogueImg}
 ];

  // 무한 루프를 위해 앞뒤로 복제된 배열 생성
  const extendedPrizes = [...prizes, ...prizes, ...prizes];
  const cloneCount = prizes.length;

  // 자동 슬라이드 효과
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // 무한 루프를 위한 리셋 처리
  useEffect(() => {
    if (currentIndex >= cloneCount * 2) {
      // 마지막 복제본 영역에 도달하면 첫 번째 복제본으로 리셋
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(cloneCount);
        setTimeout(() => setIsTransitioning(true), 50);
      }, 600);
      return () => clearTimeout(timer);
    } else if (currentIndex < cloneCount) {
      // 첫 번째 복제본 이전으로 가면 두 번째 복제본으로 리셋
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(cloneCount + currentIndex);
        setTimeout(() => setIsTransitioning(true), 50);
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, cloneCount]);

  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.7rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 12 : 16,
        paddingLeft: isMobile ? 20 : 40,
        paddingRight: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        letterSpacing: '-0.02em',
        textAlign: 'center',
        width: '100%'
      }}>
        {customerTexts.title[lang]}
      </span>
      
      {/* 수평 슬라이딩 캐러셀 영역 */}
      <div style={{
        width: '100%',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden'
      }}>
        {/* 슬라이딩 컨테이너 */}
        <div style={{
          width: '100%',
          overflow: 'hidden',
          position: 'relative'
        }}>
          <div style={{
            display: 'flex',
            width: isMobile ? `${extendedPrizes.length * 100}%` : '100%',
            transform: isMobile ? 
              `translateX(-${currentIndex * (100 / extendedPrizes.length)}%)` :
              `translateX(-${currentIndex * (100 / 5)}%)`,
            transition: isTransitioning ? 'transform 0.6s ease-in-out' : 'none'
          }}>
            {/* 복제된 아이템 배열 렌더링 */}
            {extendedPrizes.map((item, index) => (
              <div
                key={`${item.key}-${Math.floor(index / prizes.length)}-${index % prizes.length}`}
                style={{
                  width: isMobile ? `${100 / extendedPrizes.length}%` : '20%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: isMobile ? '0' : '0 10px',
                  flexShrink: 0
                }}
              >
                <div
                  style={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : '350px',
                    borderRadius: 12,
                    padding: isMobile ? 30 : 25,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minHeight: isMobile ? 200 : 130
                  }}
                >
                  <div style={{
                    width: isMobile ? 150 : 180,
                    height: isMobile ? 54 : 54,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#ffffff',
                    borderRadius: 32
                  }}>
                    <img
                      src={item.image}
                      alt={`Prize ${(index % prizes.length) + 1}`}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductHOCustomer2;